(function () {
  'use strict';

  function formatMoney(cents, stripDecimals) {
    var amount = cents / 100;
    var value = stripDecimals ? Math.round(amount) : amount;
    var formatted = value.toLocaleString(undefined, {
      minimumFractionDigits: stripDecimals ? 0 : 2,
      maximumFractionDigits: stripDecimals ? 0 : 2
    });
    return 'Rs.' + formatted;
  }

  function syncStickyPrices(variant, stripDecimals) {
    var formatted = formatMoney(variant.price, stripDecimals);
    document.querySelectorAll('[data-sticky-price], [data-sticky-price-mobile]').forEach(function (el) {
      el.textContent = formatted;
    });
  }

  function updateProductPrice(el, variant, stripDecimals) {
    var useStrip = stripDecimals !== false;
    var current = el.querySelector('.product-zero__price-current');
    var compare = el.querySelector('.product-zero__price-compare');

    if (!current) {
      el.innerHTML = '<span class="product-zero__price-current"></span>';
      current = el.querySelector('.product-zero__price-current');
    }

    if (variant.available) {
      current.textContent = formatMoney(variant.price, useStrip);
    } else {
      current.textContent = 'Sold out';
    }

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (!compare) {
        current.insertAdjacentHTML('afterend', '<s class="product-zero__price-compare"></s>');
        compare = el.querySelector('.product-zero__price-compare');
      }
      compare.textContent = formatMoney(variant.compare_at_price, useStrip);
      compare.style.display = '';
    } else if (compare) {
      compare.style.display = 'none';
    }

    syncStickyPrices(variant, useStrip);
  }

  function initProductGallery(productPage) {
    var mobileGallery = productPage
      ? productPage.querySelector('[data-gallery-mobile]')
      : document.querySelector('[data-gallery-mobile]');
    if (!mobileGallery) return;

    var track = mobileGallery.querySelector('[data-gallery-track]');
    var slides = track ? Array.from(track.querySelectorAll('[data-gallery-slide]')) : [];
    var dots = Array.from(mobileGallery.querySelectorAll('[data-gallery-dot]'));
    var prevBtn = mobileGallery.querySelector('[data-gallery-prev]');
    var nextBtn = mobileGallery.querySelector('[data-gallery-next]');
    if (!track || !slides.length) return;

    var index = 0;
    var scrollTimer;

    function setActive(indexValue) {
      index = indexValue;
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
      if (prevBtn) prevBtn.toggleAttribute('disabled', index <= 0);
      if (nextBtn) nextBtn.toggleAttribute('disabled', index >= slides.length - 1);
    }

    function goTo(targetIndex, behavior) {
      var nextIndex = Math.max(0, Math.min(slides.length - 1, targetIndex));
      var slide = slides[nextIndex];
      if (!slide) return;
      track.scrollTo({
        left: slide.offsetLeft,
        behavior: behavior || 'smooth'
      });
      setActive(nextIndex);
    }

    function syncIndexFromScroll() {
      var trackLeft = track.scrollLeft;
      var closestIndex = 0;
      var closestDistance = Infinity;
      slides.forEach(function (slide, slideIndex) {
        var distance = Math.abs(slide.offsetLeft - trackLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = slideIndex;
        }
      });
      setActive(closestIndex);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(index - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(index + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.galleryDot, 10));
      });
    });

    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(syncIndexFromScroll, 80);
    }, { passive: true });

    setActive(0);

    return {
      goToMediaId: function (mediaId) {
        if (!mediaId) return;
        var slideIndex = slides.findIndex(function (slide) {
          return String(slide.dataset.mediaId) === String(mediaId);
        });
        if (slideIndex >= 0) goTo(slideIndex);
      }
    };
  }

  function initProductCountdown() {
    function pad(value) {
      return String(value).padStart(2, '0');
    }

    document.querySelectorAll('[data-product-sale-bar]').forEach(function (bar) {
      if (bar.dataset.countdownBound === '1') return;
      bar.dataset.countdownBound = '1';

      var countdown = bar.querySelector('[data-product-countdown]');
      if (!countdown) return;

      // Fresh 10-hour (or configured) countdown every time the product page opens.
      var hours = parseFloat(bar.dataset.countdownHours);
      if (!hours || hours <= 0) hours = 10;
      var endTime = Date.now() + hours * 60 * 60 * 1000;

      var dEl = countdown.querySelector('[data-countdown-d]');
      var hEl = countdown.querySelector('[data-countdown-h]');
      var mEl = countdown.querySelector('[data-countdown-m]');
      var sEl = countdown.querySelector('[data-countdown-s]');

      function tick() {
        var diff = Math.max(0, endTime - Date.now());
        var days = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (dEl) dEl.textContent = pad(days);
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  function initProductTabs() {
    document.querySelectorAll('[data-product-tabs]').forEach(function (tabs) {
      var triggers = tabs.querySelectorAll('[data-tab-trigger]');
      var panels = tabs.querySelectorAll('[data-tab-panel]');

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var id = trigger.dataset.tabTrigger;
          var scrollTargetId = trigger.dataset.tabScroll;

          triggers.forEach(function (t) {
            t.classList.remove('is-active');
          });
          trigger.classList.add('is-active');

          if (scrollTargetId) {
            var target = document.getElementById(scrollTargetId);
            if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            if (window.jdgmCache && typeof window.jdgmCache.reloadAll === 'function') {
              window.setTimeout(function () {
                window.jdgmCache.reloadAll();
              }, 150);
            }
            return;
          }

          panels.forEach(function (panel) {
            var active = panel.dataset.tabPanel === id;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
          });
        });
      });
    });
  }

  function initProductPage() {
    var form = document.querySelector('[data-product-form-main]');
    if (!form) return;

    var productJson = document.querySelector('[data-product-json]');
    if (!productJson) return;

    var product;
    try {
      product = JSON.parse(productJson.textContent);
    } catch (e) {
      return;
    }

    var mainImage = document.querySelector('[data-product-main-image]');
    var priceEl = document.querySelector('[data-product-price]');
    var stickyBar = document.querySelector('[data-product-sticky-bar]');
    var stickyAtcMobile = document.querySelector('[data-sticky-atc-mobile]');
    var stripDecimals = true;

    form.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = form.querySelector('input[name="quantity"]');
        if (input) input.value = Math.max(1, parseInt(input.value, 10) - 1);
      });
    });

    form.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = form.querySelector('input[name="quantity"]');
        if (input) input.value = parseInt(input.value, 10) + 1;
      });
    });

    var productPage = form.closest('.product-page--zero') || document.querySelector('.product-page--zero');
    var galleryApi = initProductGallery(productPage);
    var galleryThumbs = productPage
      ? productPage.querySelectorAll('[data-gallery-thumb]')
      : document.querySelectorAll('[data-gallery-thumb]');

    function syncGalleryMedia(mediaId, imageSrc) {
      if (mainImage && imageSrc) {
        mainImage.src = imageSrc;
        mainImage.srcset = '';
      }
      if (mediaId) {
        galleryThumbs.forEach(function (thumb) {
          thumb.classList.toggle('is-active', String(thumb.dataset.mediaId) === String(mediaId));
        });
        if (galleryApi && galleryApi.goToMediaId) galleryApi.goToMediaId(mediaId);
      }
    }

    form.querySelectorAll('[data-variant-option]').forEach(function (option) {
      option.addEventListener('click', function () {
        var group = option.closest('[data-option-group]');
        group.querySelectorAll('[data-variant-option]').forEach(function (o) {
          o.classList.remove('is-selected');
        });
        option.classList.add('is-selected');

        var selectedLabel = group.querySelector('[data-selected-option]');
        if (selectedLabel) selectedLabel.textContent = option.dataset.variantOption;

        var selectedOptions = [];
        form.querySelectorAll('[data-option-group]').forEach(function (g) {
          var selected = g.querySelector('.is-selected');
          if (selected) selectedOptions.push(selected.dataset.variantOption);
        });

        var variant = product.variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === selectedOptions[i];
          });
        });

        if (variant) {
          form.querySelector('[name="id"]').value = variant.id;
          if (variant.featured_image) {
            syncGalleryMedia(variant.featured_image.id, variant.featured_image.src);
          }
          if (priceEl) updateProductPrice(priceEl, variant, stripDecimals);
          var url = new URL(window.location);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      });
    });

    galleryThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        galleryThumbs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
        syncGalleryMedia(thumb.dataset.mediaId, thumb.dataset.fullSrc);
      });
    });

    var buyNowBtn = form.querySelector('[data-buy-now]');
    if (buyNowBtn && !window.__hijabeezBuyNowBound) {
      window.__hijabeezBuyNowBound = true;
      initBuyNowFlow(form, buyNowBtn);
    }

    function submitAddToCart() {
      var addBtn = form.querySelector('[type="submit"][name="add"]');
      if (addBtn) addBtn.click();
    }

    var stickyAtcBtn = document.querySelector('[data-sticky-atc-btn]');
    if (stickyAtcBtn) stickyAtcBtn.addEventListener('click', submitAddToCart);

    var stickyMobileBtn = document.querySelector('[data-sticky-atc-mobile-btn]');
    if (stickyMobileBtn && buyNowBtn) {
      stickyMobileBtn.addEventListener('click', function () {
        buyNowBtn.click();
      });
    }

    var buySection = document.querySelector('[data-product-buy]');

    if (stickyBar && stickyBar.parentElement !== document.body) {
      document.body.appendChild(stickyBar);
    }

    function getHeaderBottom() {
      if (window.theme && typeof window.theme.measureHeaderOffsetBottom === 'function') {
        return window.theme.measureHeaderOffsetBottom();
      }

      var rootStyles = getComputedStyle(document.documentElement);
      var synced = parseFloat(rootStyles.getPropertyValue('--header-offset-bottom'));
      if (synced > 0) return synced;

      var bottom = 0;
      var selectors = [
        '.shopify-section-group-header-group .top-ticker.announcement-bar',
        '.shopify-section-group-header-group .announcement-bar',
        '[data-site-header]'
      ];

      selectors.forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (node) {
          var rect = node.getBoundingClientRect();
          var style = window.getComputedStyle(node);
          if (rect.height <= 0) return;
          if (style.display === 'none' || style.visibility === 'hidden') return;
          if (rect.bottom > bottom) bottom = rect.bottom;
        });
      });

      if (bottom > 0) return Math.ceil(bottom);

      var headerHeight = parseFloat(rootStyles.getPropertyValue('--header-height')) || 64;
      var announcementHeight = parseFloat(rootStyles.getPropertyValue('--announcement-height')) || 36;
      return Math.ceil(headerHeight + announcementHeight);
    }

    function syncStickyBarTop() {
      if (!stickyBar) return;
      var top = getHeaderBottom();
      stickyBar.style.top = top + 'px';
      document.documentElement.style.setProperty('--sticky-bar-top', top + 'px');
    }

    function updateStickyBarVisibility() {
      if (!stickyBar || !buySection) return;

      syncStickyBarTop();
      var headerBottom = getHeaderBottom();
      var buyRect = buySection.getBoundingClientRect();
      var shouldShow = buyRect.bottom <= headerBottom;

      stickyBar.classList.toggle('is-visible', shouldShow);
      stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    if (buySection && stickyBar) {
      var stickyTicking = false;
      var headerGroup = document.querySelector('.shopify-section-group-header-group');

      function scheduleStickyBarUpdate() {
        if (stickyTicking) return;
        stickyTicking = true;
        window.requestAnimationFrame(function () {
          stickyTicking = false;
          updateStickyBarVisibility();
        });
      }

      window.addEventListener('scroll', scheduleStickyBarUpdate, { passive: true });
      window.addEventListener('resize', scheduleStickyBarUpdate, { passive: true });

      if (headerGroup && typeof ResizeObserver !== 'undefined') {
        var headerResizeObserver = new ResizeObserver(scheduleStickyBarUpdate);
        headerResizeObserver.observe(headerGroup);
      }

      var siteHeader = document.querySelector('[data-site-header]');
      if (siteHeader && typeof ResizeObserver !== 'undefined') {
        var siteHeaderResizeObserver = new ResizeObserver(scheduleStickyBarUpdate);
        siteHeaderResizeObserver.observe(siteHeader);
      }

      scheduleStickyBarUpdate();
    }

    if (buySection && stickyAtcMobile) {
      var mobileObserver = new IntersectionObserver(function (entries) {
        var isVisible = !entries[0].isIntersecting;
        stickyAtcMobile.classList.toggle('is-visible', isVisible);
        document.body.classList.toggle('sticky-atc-active', isVisible);
      }, { threshold: 0 });
      mobileObserver.observe(buySection);
    }
  }

  function isCartAddUrl(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
  }

  /*
    Buy Now must clear the same validation as Add to Cart. Globo renders its
    required option pickers client-side, so instead of inspecting its markup we
    drive the real Add to Cart button and only continue to checkout once a
    /cart/add request actually succeeds.
  */
  function initBuyNowFlow(form, buyNowBtn) {
    var pending = false;
    var resetTimer = null;

    function clearPending() {
      pending = false;
      if (resetTimer) {
        window.clearTimeout(resetTimer);
        resetTimer = null;
      }
      buyNowBtn.removeAttribute('aria-busy');
    }

    function goToCheckout() {
      if (!pending) return;
      clearPending();
      window.location.href = '/checkout';
    }

    if (!window.__hijabeezCartAddWatch) {
      window.__hijabeezCartAddWatch = { handlers: [] };

      var notify = function () {
        window.__hijabeezCartAddWatch.handlers.forEach(function (fn) {
          try {
            fn();
          } catch (err) {}
        });
      };

      var originalFetch = window.fetch;
      if (typeof originalFetch === 'function') {
        window.fetch = function (input, init) {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var method = (init && init.method) || (input && input.method) || 'GET';
          var watching = isCartAddUrl(url) && String(method).toUpperCase() === 'POST';
          var request = originalFetch.apply(this, arguments);

          if (watching) {
            request.then(function (response) {
              if (response && response.ok) notify();
            });
          }

          return request;
        };
      }

      var originalOpen = XMLHttpRequest.prototype.open;
      var originalSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function (method, url) {
        this.__hijabeezCartAdd = isCartAddUrl(url) && String(method || '').toUpperCase() === 'POST';
        return originalOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function () {
        var xhr = this;
        if (xhr.__hijabeezCartAdd) {
          xhr.addEventListener('load', function () {
            if (xhr.status >= 200 && xhr.status < 300) notify();
          });
        }
        return originalSend.apply(this, arguments);
      };
    }

    window.__hijabeezCartAddWatch.handlers.push(goToCheckout);

    // Non-ajax submits land on /cart, so hand off through sessionStorage
    form.addEventListener('submit', function (event) {
      if (!pending) return;
      try {
        window.sessionStorage.setItem('hijabeezBuyNow', String(Date.now()));
      } catch (err) {}
      window.setTimeout(function () {
        if (event.defaultPrevented) {
          try {
            window.sessionStorage.removeItem('hijabeezBuyNow');
          } catch (err2) {}
        }
      }, 0);
    });

    buyNowBtn.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        pending = true;
        buyNowBtn.setAttribute('aria-busy', 'true');
        if (resetTimer) window.clearTimeout(resetTimer);
        resetTimer = window.setTimeout(clearPending, 15000);

        var addBtn = form.querySelector('[type="submit"][name="add"]');
        if (addBtn) {
          addBtn.click();
        } else if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      },
      true
    );
  }

  function boot() {
    initProductCountdown();
    initProductTabs();
    initProductPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
